<template>
  <div :class="{ 'catalog-shell': $route.path === '/SGCCV/despachos' }">
  <HeaderComponent class="content_header"/>
  <div class="main_container" :class="{ 'catalog-layout': $route.path === '/SGCCV/despachos' }">
    <Menu class="menu_content" />
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
  <FooterComponent class="content_footer" :elevation="10" />
  </div>
</template>

<script>
import FooterComponent from './Footer.vue'
import HeaderComponent from './Header.vue'
import Menu from './Menu.vue'

export default {
  name: 'TemplateComponent',
  components: {
    FooterComponent,
    HeaderComponent,
    Menu,
  },
  props: {
    msg: String
  },
  data() {
    return {
      snackbarData: {
        openSnackbar: false,
        description: ''
      }
    };
  }
}
</script>

<style scoped>

  

  .content_footer {
    height: 5vh;
  }

  .main_container {
    height: 84vh;
    display: flex;
    flex-direction: row;
  }

  .menu_content {
    position: relative;
    z-index: 1;
    width: 71px;
  }

  .container {
    flex: 1;
    width: calc(100vh - 71px);
    height: 84vh;
  }

  .catalog-shell { display: flex; flex-direction: column; height: 100dvh; overflow: hidden; }
  .catalog-shell .content_header { height: auto; flex-shrink: 0; }
  .catalog-shell .main_container { flex: 1; min-height: 0; height: auto; }
  .catalog-shell .container { height: 100%; }
  .catalog-shell .menu_content { height: 100%; }
  .catalog-shell .content_footer { height: auto; min-height: 32px; flex-shrink: 0; padding: 4px; text-align: center; font-size: 12px; }
  .catalog-layout .container { width: 0; min-width: 0; overflow-y: auto; }
  .catalog-layout .menu_content { flex-shrink: 0; }
</style>
